import React from 'react';
import { FadeIn } from './FadeIn';
import { X, Check, Calendar, Activity, LineChart, Target } from 'lucide-react';
export function MaquinaAdministrativa() {
  const comparisons = [{
    task: 'Tiempo de gestión diaria',
    without: '45-60 minutos',
    with: '8 minutos'
  }, {
    task: 'Tracking del sistema',
    without: 'Manual en planillas',
    with: 'Automatizado con fórmulas'
  }, {
    task: 'Negociación de servicios',
    without: 'Sin guión',
    with: '8 guiones listos para usar'
  }, {
    task: 'Costos fijos mensuales',
    without: 'Sin renegociar',
    with: '$30.000-$60.000 recuperados'
  }, {
    task: 'Ingresos extra',
    without: 'Nivel básico',
    with: 'Escalada a retenciones en USD'
  }, {
    task: 'Crisis cambiaria',
    without: 'Reacción al azar',
    with: 'Radar de 10 puntos activo'
  }, {
    task: 'Resguardo en USD',
    without: 'Solo USDT básico',
    with: 'USDT + ON + Portfolio por etapa'
  }, {
    task: 'Resultado en 12 meses',
    without: '$25.000-$50.000/mes',
    with: '$150.000-$350.000/mes + U$S 300-800'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-5xl mx-auto" data-id="element-225">
      <FadeIn data-id="element-226">
        <div className="text-center mb-6 md:mb-12" data-id="element-227">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 rounded-full bg-[#C9A84C]/10 mb-3 md:mb-6 border border-[#C9A84C]/20 relative" data-id="element-228">
            <div className="absolute inset-0 bg-[#C9A84C]/20 blur-xl rounded-full animate-pulse" data-id="element-229"></div>
            <Activity className="text-[#b8924a] relative z-10 w-7 h-7 md:w-10 md:h-10" data-id="element-230" />
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] mb-2 md:mb-4 px-2" data-id="element-231">
            ¿QUÉ AGREGA EL ACELERADOR ESTRATÉGICO?
          </h2>
          <p className="text-sm md:text-xl text-[#475569] font-bold max-w-2xl mx-auto" data-id="element-232">
            El sistema que convierte el conocimiento en ejecución automática.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-6 md:mb-12" data-id="element-233">
        <FadeIn delay={0.2} data-id="element-234">
          <div className="bg-[#ef4444]/5 border border-[#ef4444]/20 rounded-2xl p-4 md:p-8 h-full" data-id="element-235">
            <div className="flex items-center gap-3 mb-4 md:mb-8 pb-3 md:pb-4 border-b border-[#ef4444]/10" data-id="element-236">
              <div className="bg-[#ef4444]/10 p-1.5 md:p-2 rounded-lg" data-id="element-237">
                <X className="text-[#ef4444] w-5 h-5 md:w-6 md:h-6" data-id="element-238" />
              </div>
              <h3 className="text-base md:text-xl font-black text-[#ef4444]" data-id="element-239">
                Sin Acelerador
              </h3>
            </div>
            <div className="space-y-3 md:space-y-6" data-id="element-240">
              {comparisons.map((item, i) => <div key={i} className="flex flex-col gap-0.5 md:gap-1" data-id="element-241">
                  <span className="text-xs md:text-sm text-[#475569] font-bold" data-id="element-242">
                    {item.task}
                  </span>
                  <span className="text-base md:text-lg font-mono text-[#0f172a] font-medium" data-id="element-243">
                    {item.without}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-244">
          <div className="bg-white border-2 border-[#C9A84C]/50 rounded-2xl p-4 md:p-8 h-full relative overflow-hidden shadow-[0_10px_30px_rgba(201,168,76,0.1)]" data-id="element-245">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#C9A84C]/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-246"></div>

            <div className="flex items-center gap-3 mb-4 md:mb-8 pb-3 md:pb-4 border-b border-[#C9A84C]/20 relative z-10" data-id="element-247">
              <div className="bg-[#C9A84C] p-1.5 md:p-2 rounded-lg shadow-[0_0_15px_rgba(201,168,76,0.5)]" data-id="element-248">
                <Check className="text-[#020617] w-5 h-5 md:w-6 md:h-6" strokeWidth={3} data-id="element-249" />
              </div>
              <h3 className="text-base md:text-xl font-black text-[#b8924a]" data-id="element-250">
                Con Acelerador
              </h3>
            </div>
            <div className="space-y-3 md:space-y-6 relative z-10" data-id="element-251">
              {comparisons.map((item, i) => <div key={i} className="flex flex-col gap-0.5 md:gap-1" data-id="element-252">
                  <span className="text-xs md:text-sm text-[#475569] font-bold" data-id="element-253">
                    {item.task}
                  </span>
                  <span className="text-sm md:text-lg font-mono font-black text-[#020617] bg-[#C9A84C]/20 w-fit px-2 md:px-3 py-0.5 md:py-1 rounded-md border border-[#C9A84C]/30" data-id="element-254">
                    {item.with}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={0.4} data-id="element-255">
        <div className="flex flex-wrap justify-center gap-2 md:gap-6" data-id="element-256">
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e2e8f0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#0f172a] shadow-sm" data-id="element-257">
            <Calendar size={14} className="text-[#C9A84C]" data-id="element-258" /> Automatización
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e2e8f0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#0f172a] shadow-sm" data-id="element-259">
            <Activity size={14} className="text-[#C9A84C]" data-id="element-260" /> Renegociación
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e2e8f0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#0f172a] shadow-sm" data-id="element-261">
            <LineChart size={14} className="text-[#C9A84C]" data-id="element-262" /> Escalada
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e2e8f0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#0f172a] shadow-sm" data-id="element-263">
            <Target size={14} className="text-[#C9A84C]" data-id="element-264" /> Radar
          </div>
        </div>
        <p className="text-center text-sm md:text-base text-[#b8924a] font-black mt-3 md:mt-6" data-id="element-265">
          Automatización · Renegociación · Escalada · Radar · Resultados
          medibles
        </p>
      </FadeIn>
    </section>;
}